import React from "react";
import { pointsConfig } from "../../pointsConfig";

function MilesPointsBadgesSection() {
  const badges = [
    {
      type: pointsConfig.badges.person.code,
      completed: true,
      title: "Verified Partner",
      description: "After completing KYC and platform verification steps.",
      total: 4,
      completedItems: 2,
    },
    {
      type: pointsConfig.badges.rocket.code,
      completed: true,
      title: "First Sale",
      description: "After the first successful booking on the platform.",
      total: 1,
      completedItems: 0,
    },
    {
      type: pointsConfig.badges.star.code,
      completed: false,
      title: "Daily Dealer",
      description: "Logging in and performing actions every day for 14 days.",
      total: 14,
      completedItems: 12,
    },
    {
      type: pointsConfig.badges.flight.code,
      completed: false,
      title: "Flight Pro",
      description: "Booking 50+ flight tickets through the platform.",
      total: 50,
      completedItems: 34,
    },
    {
      type: pointsConfig.badges.hotel.code,
      completed: false,
      title: "Hotel Hero",
      description: "Completing 30+ hotel bookings in a month.",
      total: 30,
      completedItems: 20,
    },
    {
      type: pointsConfig.badges.tour.code,
      completed: false,
      title: "Tour Specialist",
      description: "Selling 10+ tours or experiences in a week.",
      total: 10,
      completedItems: 8,
    },
    {
      type: pointsConfig.badges.insurance.code,
      completed: false,
      title: "Insurance Ally",
      description: "Bundling travel insurance with 20+ trips.",
      total: 20,
      completedItems: 2,
    },
    {
      type: pointsConfig.badges.shop.code,
      completed: false,
      title: "Power Seller",
      description: "Achieving a monthly sales goal set on platform.",
      total: 5,
      completedItems: 2,
    },
    {
      type: pointsConfig.badges.package.code,
      completed: false,
      title: "Multi-Product Master",
      description: "Successfully selling all four products in a single month.",
      total: 4,
      completedItems: 2,
    },
    {
      type: pointsConfig.badges.partner.code,
      completed: true,
      title: "Top Partner",
      description:
        "Ranking in the top 10% of agencies based on volume or revenue.",
      total: 100, // Since the image shows 22%, total should be 100 for percent badges
      completedItems: 22,
    },
    {
      type: pointsConfig.badges.marketplace.code,
      completed: false,
      title: "Marketplace Engager",
      description:
        "Using key platform features like quote, and comparison, at least 10 times.",
      total: 10,
      completedItems: 3,
    },
    {
      type: pointsConfig.badges.repeat.code,
      completed: false,
      title: "Repeat Buyer",
      description: "Purchasing from the same supplier 3 times or more",
      total: 3,
      completedItems: 2,
    },
  ];

  return (
    <div className="w-full flex flex-wrap justify-between gap-10 px-10 mt-6">
      {badges?.map((item, index) => (
        <MilesPointsBadge key={index} badge={item} />
      ))}
      {badges.length % 2 === 0 ? <div className="w-[412px]"></div> : <></>}
    </div>
  );
}

export default MilesPointsBadgesSection;

export const MilesPointsBadge = ({ badge }) => {
  const icon = () => {
    let icon = ["", ""];

    switch (badge?.type) {
      case pointsConfig.badges.tour.code:
        icon = [
          pointsConfig.badges.tour.active,
          pointsConfig.badges.tour.inactive,
        ];
        break;
      case pointsConfig.badges.person.code:
        icon = [
          pointsConfig.badges.person.active,
          pointsConfig.badges.person.inactive,
        ];
        break;
      case pointsConfig.badges.rocket.code:
        icon = [
          pointsConfig.badges.rocket.active,
          pointsConfig.badges.rocket.inactive,
        ];
        break;
      case pointsConfig.badges.star.code:
        icon = [
          pointsConfig.badges.star.active,
          pointsConfig.badges.star.inactive,
        ];
        break;
      case pointsConfig.badges.flight.code:
        icon = [
          pointsConfig.badges.flight.active,
          pointsConfig.badges.flight.inactive,
        ];
        break;
      case pointsConfig.badges.hotel.code:
        icon = [
          pointsConfig.badges.hotel.active,
          pointsConfig.badges.hotel.inactive,
        ];
        break;
      case pointsConfig.badges.insurance.code:
        icon = [
          pointsConfig.badges.insurance.active,
          pointsConfig.badges.insurance.inactive,
        ];
        break;
      case pointsConfig.badges.shop.code:
        icon = [
          pointsConfig.badges.shop.active,
          pointsConfig.badges.shop.inactive,
        ];
        break;
      case pointsConfig.badges.package.code:
        icon = [
          pointsConfig.badges.package.active,
          pointsConfig.badges.package.inactive,
        ];
        break;
      case pointsConfig.badges.partner.code:
        icon = [
          pointsConfig.badges.partner.active,
          pointsConfig.badges.partner.inactive,
        ];
        break;
      case pointsConfig.badges.marketplace.code:
        icon = [
          pointsConfig.badges.marketplace.active,
          pointsConfig.badges.marketplace.inactive,
        ];
        break;
      case pointsConfig.badges.repeat.code:
        icon = [
          pointsConfig.badges.repeat.active,
          pointsConfig.badges.repeat.inactive,
        ];
        break;
      default:
        break;
    }

    if (badge?.completed) return icon[0];
    return icon[1];
  };

  return (
    <div className="w-[412px] h-64 rounded-xl bg-white flex flex-col items-center p-4 relative">
      <div className="absolute top-4 right-4">
        {badge?.completed ? (
          <span className="text-[#0B662C] text-sm rounded-md px-2 py-1 pb-[6px] font-BrFirmaBold bg-[#0B662C]/10">
            Completed
          </span>
        ) : (
          <span className="text-[#2E2E32] rounded-md text-sm px-2 py-1 pb-[6px] bg-[#F9F9F9] border border-[#E0E0E0]">
            {badge?.completedItems}/{badge?.total}
          </span>
        )}
      </div>
      <img src={icon()} alt="" className="w-24 object-contain" />
      <span className="font-BrFirmaBold text-lg text-center max-w-[80%] mt-4">
        {badge?.title}
      </span>
      <span className="text-center max-w-[80%] text-[#6D7C94] mt-1">
        {badge?.description}
      </span>
    </div>
  );
};
